import { Box } from '@mui/material';

export function Logo() {
  return (
    <Box padding={2}>
      <img src="/static/apono-logo.svg" alt="Apono" width={120} />
    </Box>
  );
}
